export default [
  {
    "id": "0",
    "date": "2018-06-23T19:03:23.000Z",
    "author": "Марк Аврелий",
    "title": "",
    "text": "Делай, что должно, и будь что будет.",
    "category": [
      "девиз",
      "дух",
      "латынь",
      "нонконформизм",
    ],
  },
  {
    "id": "1",
    "date": "2018-06-23T15:03:23.000Z",
    "author": "Хань Сян-Цзы",
    "title": "",
    "text": "Всё, что важно, не бывает срочно. Всё, что срочно - только суета.",
    "category": [
      "дух",
      "Китай",
      "психология",
    ],
  },
  {
    "id": "2",
    "date": "2018-06-23T18:03:23.000Z",
    "author": "Шаво Одаджян",
    "title": "",
    "text": "Помните: будьте свободны в своих мыслях и оставайтесь опасными!",
    "category": [
      "дух",
      "музыка",
      "нонконформизм",
    ],
  },
  {
    "id": "3",
    "date": "2018-06-23T11:03:23.000Z",
    "author": "Фрэнк Заппа",
    "title": "",
    "text": "Если ты всегда слушал папу с мамой, школьных учителей, священников и какого-то дядьку в телевизоре, а теперь из-за этого ведешь скучную и несчастную жизнь - то, парень, ты этого заслуживаешь.",
    "category": [
      "дух",
      "музыка",
      "нонконформизм",
    ],
  },
  {
    "id": "4",
    "date": "2018-06-23T11:03:23.000Z",
    "author": "Фрэнк Хэрберт",
    "title": "Дюна",
    "text": "Я не должен бояться.\n" +
    "Страх — убийца разума.\n" +
    "Страх — это маленькая смерть, влекущая за собой полное уничтожение.\n" +
    "Я встречусь лицом к лицу со своим страхом.\n" +
    "Я позволю ему пройти через меня и сквозь меня.\n" +
    "И, когда он уйдет, я обращу свой внутренний взор на его путь.\n" +
    "Там, где был страх, не будет ничего.\n" +
    "Останусь лишь я.",
    "category": [
      "дух",
      "нонконформизм",
      "литература",
    ],
  },
]


// WEBPACK FOOTER //
// ./src/quotes_base.js